import styles from '../Select/Select.module.css';
import { useEffect, useState } from 'react';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';

const DropdownMenuItem = ({
    children,
    icon,
    hasChildren,
    disabled,
    onClick,
    readOnly,
    borderBottom,
    borderTop,
    subTitle,
    isSelected,
    iconSize = 'base',
    blurOnClick = true,
}: {
    children: React.ReactNode;
    icon?: Icons;
    hasChildren?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    onClick?: (e: React.MouseEvent<HTMLLIElement>) => void;
    borderBottom?: boolean;
    borderTop?: boolean;
    subTitle?: string;
    isSelected?: boolean;
    iconSize?: 'md' | 'base';
    blurOnClick?: boolean;
}) => {
    return (
        <li
            className={`${styles.dropdownMenuItem} 
            ${styles.optionOuter} 
            ${disabled ? styles.dropdownMenuItemDisabled : ''}
            ${readOnly ? styles.readOnly : ''}
            ${borderBottom ? styles.borderBottom : ''}
            ${borderTop ? styles.borderTop : ''}
            ${isSelected ? styles.optionSelected : ''}
            `}
            onClick={(e) => {
                if (disabled || readOnly) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                onClick?.(e);
                if (!hasChildren && blurOnClick) {
                    // @ts-ignore
                    document?.activeElement?.blur();
                }
            }}
        >
            <span
                className={`
            ${styles.optionCompact} 
            ${readOnly ? styles.readOnly : ''}
           `}
            >
                <span
                    className={`${styles.dropdownMenuItemInner} 
                    ${!!icon ? `${styles.dropdownMenuItemInnerWithIcon} ${iconSize ? styles[`icon-${iconSize}`] : ''}` : ''}`}
                >
                    {icon && <Icon icon={icon} />}
                    <span className={styles.dropdownMenuItemInnerLabel}>
                        {' '}
                        {children}
                        {subTitle && <span className={styles.dropdownMenuItemInnerSubLabel}>{subTitle}</span>}
                    </span>
                </span>

                {hasChildren ? (
                    <span className={styles.iconRight}>
                        <Icon icon={Icons.chevronRight} />
                    </span>
                ) : isSelected ? (
                    <span className={styles.iconRight}>
                        <Icon icon={Icons.check} />
                    </span>
                ) : null}
            </span>
        </li>
    );
};

const DropdownMenu = ({
    children,
    options = [],
    value,
    valueKey = 'value',
    labelKey = 'label',
    filterKey,
    isMulti = false,
    onCreateOption,
    onChange,
    disabled,
    info,
    extended,
    placeholder,
    style,
    afterLabel,
    menuPlacement,
    margin,
    dropdownTrigger,
    className,
    dropDownMenuClassName,
    position,
    onFocus,
    onBlur,
    hasMinWidth = true,
    ...props
}: any) => {
    const [customValue, setCustomValue] = useState<any>(undefined);
    const [_menuPlacement, setMenuPlacement] = useState<string>('bottom');

    const getValue = () => {
        const option = !value
            ? ''
            : Array.isArray(value)
              ? value
              : typeof value !== 'object'
                ? options.find((option: any) => (option[valueKey] || option.value) === value)
                : value;

        const endValue = Array.isArray(value)
            ? value
            : option
              ? {
                    label: option[labelKey] || option.label || option.name,
                    value: option[valueKey] || option.value || option.id,
                }
              : '';

        if (JSON.stringify(customValue) != JSON.stringify(endValue)) {
            setCustomValue(
                Array.isArray(value)
                    ? value
                    : option
                      ? {
                            label: option[labelKey] || option.label || option.name,
                            value: option[valueKey] || option.value || option.id,
                        }
                      : '',
            );
        }
    };

    useEffect(() => {
        getValue();
    }, [value, options]);

    // useEffect(() => {
    // setSelectedFilters([]);
    // }, [options]);

    return (
        <div
            className={`
            ${styles.dropdown}
            ${styles.dropdownCustom}
            ${className || ''}
            ${position === 'fixed' ? styles.fixed : ''}
            `}
            tabIndex={-1}
            onFocusCapture={onFocus}
            onBlurCapture={onBlur}
        >
            {dropdownTrigger}
            <ul
                className={`${styles.dropdownMenuCustom} 
                ${hasMinWidth ? styles.minWidth : ''}
                ${styles.dropdownMenu} 
                ${menuPlacement === 'top' ? styles.dropdownMenuCustomTop : ''}
                ${dropDownMenuClassName || ''}
                `}
            >
                {children}
            </ul>
        </div>
    );
};

export default DropdownMenu;
export { DropdownMenu, DropdownMenuItem };
